import { createReducer, on } from '@ngrx/store';

import * as ThirdPartyStepperActions from '@ruby/modules/third-party/store/actions/third-party-stepper.actions';

export const featureKey = 'stepper';

export interface State {
  isEdit: boolean;
  isNewLOA: boolean;
  stepIndex: number;
  isDoneEnabled: boolean;
}

export const initialState: State = {
  isEdit: false,
  isNewLOA: false,
  stepIndex: 0,
  isDoneEnabled: false
};

export const reducer = createReducer(
  initialState,
  on(ThirdPartyStepperActions.setEditMode, (state, action) => ({
    ...state,
    isEdit: action.data
  })),
  on(ThirdPartyStepperActions.setNewLOA, (state, action) => ({
    ...state,
    isNewLOA: action.data
  })),
  on(ThirdPartyStepperActions.setStepIndex, (state, action) => ({
    ...state,
    stepIndex: action.data
  })),
  on(ThirdPartyStepperActions.enableDone, (state, action) => ({
    ...state,
    isDoneEnabled: action.data
  })),
  on(ThirdPartyStepperActions.clear, (state, action) => initialState)
);
